export const VEHICLE_DETAILS_MAIN_TABS_ID = {
  vehicle: 'vehicleTab',
  organization: 'organizationTab',
  leasing: 'leasingTab',
  vehicleHistory: 'vehicleHistoryTab',
  vehicleDocuments: 'vehicleDocumentsTab',
  notes: 'notesTab'
};
